import { render } from "./FAQ.vue?vue&type=template&id=05d404e7&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=05d404e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d404e7"]])

export default __exports__